import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import RequestedMeeting from './Meeting/RequestedMeeting';
import ApprovedMeeting from './Meeting/ApprovedMeeting';
import { useAppStore } from '../store/appStore';
import PreRequestedMeeting from './Meeting/PreRequestedMeeting';
import RejectedMeeting from './Meeting/RejectedMeeting';
import CompletedMeeting from './Meeting/CompletedMeeting';

type MeetingStatus =
  | 'MARKETING'
  | 'REQUESTED'
  | 'APPROVED'
  | 'REJECTED'
  | 'CANCELLED'
  | 'COMPLETED';

interface TabItem {
  key: MeetingStatus;
  label: string;
  children: React.ReactNode;
}

const Meetings: React.FC = () => {
  const profile = useAppStore((state) => state.profile);
  const role = profile?.user.role.roleName;

  // Determine visible tabs based on role
  const allTabs: TabItem[] = [
    { key: 'MARKETING', label: 'Requested', children: <PreRequestedMeeting /> },
    { key: 'REQUESTED', label: 'In Planning', children: <RequestedMeeting /> },
    { key: 'APPROVED', label: 'Scheduled', children: <ApprovedMeeting /> },
    { key: 'REJECTED', label: 'Rejected', children: <RejectedMeeting /> },
    { key: 'COMPLETED', label: 'Completed', children: <CompletedMeeting /> },
  ];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const visibleTabs: TabItem[] =
    role === 'Marketing Manager'
      ? allTabs.filter((tab:any) => tab.key === 'MARKETING' || tab.key === 'REJECTED' || tab.key === 'COMPLETED' || tab.key === 'APPROVED' || tab.key === 'REQUESTED')
      : role === 'Meeting Manager' || role === 'Super Admin'
        ? allTabs.filter((tab:any) => tab.key !== 'MARKETING')
        : [];

  // Ensure active tab is always valid
  const [activeTab, setActiveTab] = useState<MeetingStatus | undefined>(
    visibleTabs.length > 0 ? visibleTabs[0].key : undefined
  );

  useEffect(() => {
    if (visibleTabs.length > 0 && !visibleTabs.some((tab) => tab.key === activeTab)) {
      setActiveTab(visibleTabs[0].key);
    }
  }, [role, visibleTabs, activeTab]);

  const handleTabChange = (key: string) => {
    setActiveTab(key as MeetingStatus);
  };

  return (
    <div className="!p-4 bg-white rounded-lg shadow">
      <h2 className="text-xl font-semibold mb-4">Meetings</h2>
      {visibleTabs.length > 0 ? (
        <Tabs activeKey={activeTab} onChange={handleTabChange} items={visibleTabs} type="card" />
      ) : (
        <p className="text-gray-500">No meetings available for your role.</p>
      )}
    </div>
  );
};

export default Meetings;
